import axios from "axios";

export default {
    name: 'stock',
    state: {
        stock: [],
        saleline: [],
        invoiceForm: {},
        localid: ''
    },
    getters: {
        getStock: (state) => state.stock,
        getLocalid: (state) => state.localid,
        getInvoiceForm: (state) => state.invoiceForm,
        getCurrentSaleLine: (state) => state.saleline,
        getTotalsaleLines: (state) => {
            return state.saleline.reduce((total, saleline) => {
                return total + (saleline.Qty * saleline.sellingPrice);
            }, 0);
        },
    },
    mutations: {
        setStock: (state, stock) => state.stock = stock,
        setLocalid: (state, stock) => state.localid = stock,
        setInvoiceForm: (state, data) => {
            state.invoiceForm = {...state.invoiceForm, ...data};
        },
        addToCart: (state, stock) => {
            const existingItemIndex = state.saleline.findIndex(
                item => item.plu === stock.plu
            );
            if (existingItemIndex !== -1) {
                return state.saleline[existingItemIndex].Qty += 1;
            } else {
                const newItem = {
                    ...stock,
                    Qty: 1,
                };
                state.saleline.push(newItem);
            }
        },
        decrementItem(state, stock) {
            const existingItemIndex = state.saleline.findIndex(
                item => item.plu === stock.plu
            );

            if (existingItemIndex !== -1) {
                if (state.saleline[existingItemIndex].Qty === 1) {
                    return this.commit('removeItem', existingItemIndex);
                } else {
                    return state.saleline[existingItemIndex].Qty -= 1;
                }
            } else {
                console.log('Item not found in saleline.');
            }
        },
        removeItem(state, index) {
            if (index >= 0 && index < state.saleline.length) {
                state.saleline.splice(index, 1);
            } else {
                console.error('Invalid index:', index);
            }
        },
    },
    actions: {
        getAuditNumber(context, payload) {
            return axios.get(`${portalApi}invoice/getInvoiceNumber?invoiceType=${payload}`)
                .then(({data}) => context.commit('setInvoiceForm', data.response))
                .catch(err => errorHandler.tomcatError(err));
        },
        processTransaction: (context) => {
            const saleDetails = context.getters.getInvoiceForm
            let stock = context.getters.getStock;
            const lines = context.state.saleline.map(item => {
                const stockItem = stock.find(stockItem => stockItem.plu === item.plu);
                const newQty = stockItem ? stockItem.qty - item.Qty : 0;

                return {
                    plu: item.plu,
                    department: item.department,
                    type: item.pkgUnitCd,
                    name: item.itemName,
                    description: item.itemName, // Exactly the same as "name"
                    archive: false, // Always False
                    vatCat: item.vatCatCd,
                    uom: item.pkgUnitCd,
                    lineTotal: item.sellingPrice * item.Qty, // unit price * qty
                    qty: item.Qty, // Hardcoded, ensure this is intentional
                    discountPercent: 0.0, // Always 0
                    newQty: newQty, // item qty - sold qty
                    countryOfOrigin: "ZM", // Hardcoded, ensure this is intentional
                    autoCreate: true, // Always True
                    declined: false, // Always false
                    imported: false // Always false
                };
            });

            const payload = {
                autoCreate: true, // Always True
                currency: "ZMW", // Always ZMW
                rate: 1.0, // Always 1.0
                isLpo: !!saleDetails.Lpo, // TRUE if Invoice Type == LPO
                lpo: saleDetails.lpoNumber,
                isExport: false, // Always false
                isDebit: false, // Always false
                user: "LytSoft", // Always Lyt-Soft
                refund: false, // Always false
                auditNumber: saleDetails.auditNumber,
                tpin: saleDetails.tpin,
                note: saleDetails.note, // Any Additional Notes Needed
                lines: lines,
                manageStock: true // Always True
            }
            console.log(payload);

            const Apikey = context.getters.getApikey;
            const headers = Apikey ? { 'Api-key': Apikey } : {};
            return context.dispatch(`sendRequest`, {
                url: `${SmartInvoiceApi}invoice/create`,
                payload,
                headers
            }).then((response) => {
                try {
                    return context.dispatch(`rePrints`, {localid: this.$store.getters.getLocalid, reprint: false})
                } catch (e) {
                    console.trace(e)
                }
            })

        },
        stock(context, payload) {
            const Apikey = context.getters.getApikey;
            const headers = Apikey ? { 'Api-key': Apikey } : {};
            if (!payload) {
                payload = 500
            }
            return axios.get(`${portalApi}product/search?limit=${payload}`, {headers})
                .then(({data}) => context.commit('setStock', data.response))
                .catch(err => errorHandler.tomcatError(err));
        },
        searchStock(context, params) {
            const Apikey = context.getters.getApikey;
            const headers = Apikey ? { 'Api-key': Apikey } : {};
            return axios.get(`${portalApi}product/search`, {
                headers,
                params
            }).then(({data}) => data.response).catch(err => errorHandler.tomcatError(err));
        },

        searchStockExcel: async (context, params) => {
            const Apikey = context.getters.getApikey;
            const headers = Apikey ? { 'Api-key': Apikey } : {};

            try {
                const response = await axios.get(`${portalApi}product/searchExcel`,{ headers, params, responseType: 'blob'});
                // Create a link element to trigger the download
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'stock_items.xlsx'); // Set the file name
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Error downloading the file:', error);
            }
        },
        exportStockExcel: async (context) => {
            const Apikey = context.getters.getApikey;
            const headers = Apikey ? { 'Api-key': Apikey } : {};

            try {
                const response = await axios.get(`${portalApi}product/exportAllStock`,{ headers, responseType: 'blob'});
                // Create a link element to trigger the download
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'stock_items.xlsx'); // Set the file name
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Error downloading the file:', error);
            }
        },
    }
}
